export enum ReportsTemplateListType {
  ALL = 'All Templates',
  PREDEFINED = 'Predefined Templates',
  MY_TEAMS = 'My Team’s Templates'
}
